import { render } from "./NotificationBar.vue?vue&type=template&id=6ca1be53"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"
script.render = render

export default script